var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0687 3.17548C16.5066 1.61339 13.9739 1.61338 12.4118 3.17547L5.50573 10.0815C5.22828 10.359 5.03857 10.7119 4.96022 11.0964L4.04242 15.6001C3.75618 17.0047 4.99701 18.2454 6.40157 17.9592L10.9051 17.0412C11.2896 16.9629 11.6425 16.7732 11.9199 16.4957L18.826 9.5897C20.3881 8.0276 20.3881 5.49493 18.826 3.93283L18.0687 3.17548ZM13.826 4.58969C14.6071 3.80864 15.8734 3.80865 16.6545 4.58969L17.4118 5.34705C18.1929 6.1281 18.1929 7.39443 17.4118 8.17548L17.0002 8.58712L13.4144 5.00133L13.826 4.58969ZM12.0002 6.41554L8.41437 10.0013L12.0002 13.5871L15.586 10.0013L12.0002 6.41554ZM6.91994 11.4957L7.00015 11.4155L10.5859 15.0013L10.5057 15.0815L6.00214 15.9995L6.91994 11.4957ZM5 20C4.44772 20 4 20.4477 4 21C4 21.5523 4.44772 22 5 22H19C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20H5Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLine);
export default __webpack_public_path__ + "static/media/edit-line.f1e63b14fe4e5743db612722b8c8af8b.svg";
export { ForwardRef as ReactComponent };